import { useEffect, useMemo, useState } from "react";
import { monogram, tidyUrl } from "../lib/format.js";

export default function Members({ members }) {
  const [branch, setBranch] = useState("Alle");

  const branches = useMemo(() => {
    const s = new Set(members.map((m) => m.branch).filter(Boolean));
    return ["Alle", ...Array.from(s).sort((a, b) => a.localeCompare(b, "de"))];
  }, [members]);

  // Wird eine Branche in der Verwaltung entfernt, darf der Filter nicht hängen bleiben.
  useEffect(() => {
    if (!branches.includes(branch)) setBranch("Alle");
  }, [branches, branch]);

  const shown = members
    .filter((m) => branch === "Alle" || m.branch === branch)
    .sort((a, b) => a.name.localeCompare(b.name, "de"));

  return (
    <section className="section section-alt members" id="mitglieder">
      <div className="wrap">
        <p className="eyebrow">Mitglieder</p>
        <h2>{members.length} Firmen, die genau da stehen, wo du stehst.</h2>
        <p className="section-lead">
          Vom Zweipersonenbetrieb bis zur Firma mit eigener Werkstatt. Gegründet in den letzten
          Jahren, geführt von den Inhaberinnen und Inhabern selbst.
        </p>

        {branches.length > 2 ? (
          <div className="filters" role="group" aria-label="Nach Branche filtern">
            {branches.map((b) => (
              <button
                key={b}
                className="chip"
                data-on={branch === b}
                aria-pressed={branch === b}
                onClick={() => setBranch(b)}
              >
                {b}
              </button>
            ))}
          </div>
        ) : null}

        {shown.length ? (
          <div className="member-grid">
            {shown.map((m) => (
              <article className="member" key={m.id}>
                {m.logo ? (
                  <div className="member-logo">
                    <img src={`/uploads/${m.logo}`} alt={`Logo ${m.name}`} loading="lazy" />
                  </div>
                ) : (
                  <div className="member-mono" aria-hidden="true">
                    {monogram(m.name)}
                  </div>
                )}
                <div style={{ minWidth: 0 }}>
                  <h3>{m.name}</h3>
                  <div className="member-meta">
                    {[m.branch, m.city].filter(Boolean).join(" · ")}
                  </div>
                  {m.description ? <p>{m.description}</p> : null}
                  <div className="member-small">
                    {m.contact ? <div>{m.contact}</div> : null}
                    {m.since ? <div>Dabei seit {m.since}</div> : null}
                  </div>
                  {m.website ? (
                    <a
                      className="member-link"
                      href={tidyUrl(m.website)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Website öffnen
                    </a>
                  ) : null}
                </div>
              </article>
            ))}
          </div>
        ) : (
          <p className="empty">Für diese Branche ist noch keine Firma erfasst.</p>
        )}
      </div>
    </section>
  );
}
